import { Component } from "react";

export class AppFailureBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="axon-bootstrap" role="alert">
        <span className="axon-bootstrap__brand">AXONLEADS</span>
        <span className="axon-bootstrap__signal" aria-hidden="true" />
        <h1>Не удалось открыть приложение</h1>
        <p>Закройте AxonLeads, проверьте интернет и откройте приложение ещё раз.</p>
        <button type="button" onClick={() => globalThis.location?.reload?.()}>
          Повторить
        </button>
      </main>
    );
  }
}
